//this is largely a port of the old PHP version of the estimator, and should be refactored to be more consistent with other frontent appliactions on this site.
//it may also need a backend to store existing estimates, and create PDF's for download. The existing PDF 'converter' can probably be used for this.


//TODO -- values should be obtained from <select> elements (meaning we can just add new values to the dropdowns, and it will propigate through all the code)
//TODO -- the calculations can be much more efficient, and many of the variables can be eliminated by combining steps
//TODO -- most of these variables can be straight up removed, as they will be in <select> elements
//TODO -- still need to get pricing data from the user, and also verify if they are allowed to see cinema pricing or not

//sqFtPrices is rendered in its own <script> tag by the page template (so it has access to customer tags)

//packaging price array
let packagingPrices = {
  tube: 8,
  tray: 16,
  crate: 9,
  foldedSilver: 18,
  foldedWhite: 40
}

//packaging types enum
let packagingTypes = {
  tubeOnly: "Rolled - Tube Only",
  trayTube: "Rolled - Tray and Tube",
  rolledCrate: "Rolled - Full Crate",
  foldedCrate: "Folded Screen - Crate",
  foldedBox: "Folded White - Cardboard"
}

//dimensions per unit of various components
let dimensionMultipliers = {
  vinyl: 0.11,
  sixTube: 1.6,
  twelveTube: 4.0,
  fourteenTube: 5.0,
  misc: 0.04,
  crates: 19.0,
  trays: 4.2
}

//base strings for various product dimensions
let dimensionStrings = {
  tubeSize: 'ft x 15" Tube',
  tubeSizeM: 'm x 40cm Tube',
  traySize: 'ft x 16" x 16"',
  traySizeM: 'm x 40cm x 40cm',
  crateSize: 'ft x 22" x 18"',
  crateSizeM: 'm x 60m x 50cm',
  foldedSilverSize: '" x 24" x 29"',
  foldedSilverSizeM: 'm x 60cm x 75cm',
  foldedWhiteSize: '36" x 36" x 6"',
  foldedWhiteSizeM: '1m x 1m x 15cm'
}

//multipliers for common (and uncommon) units to convert to feet
//multiply by this number to convert to feet
//multiply by the inverse (1/n) to convert from feet
let units = {
  feet: 1.0,
  inches: 0.08333,
  meters: 3.28084,
  centimeters: 0.03281,
  
  //just for laughs
  miles: 5280.0,
  kilometers: 3280.84,
  
  //obviously ridiculous
  beardSeconds: 1.64042e-8,
  lightYears: 3.104e+16,
  planckLengths: 5.24934e-35,	//smallest meaningful unit
  universeLengths: 2.89E+27		//size of the (observable) universe
}

//calculate base estimate from screen size, coating, and packaging
function calculateEstimate(unit, width, height, coating, packaging) {
  //make sure width & height are in the right order
  if (height > width) {
    [width, height] = [height, width];
  }
  
  //convert to ft before doing the rest of the calculations
  width *= unit;
  height *= unit;
  
  //size in square feet
  let sqFt = width * height;
  
  let [AE, AF] = [0, 0];
  let tubeLength = (height + 2);
  
  //various costs to factor in
  let screenCost = sqFt * sqFtPrices[coating];
  let vinylPerSqFt = sqFt * dimensionMultipliers.vinyl;
  let miscPerSqFt = sqFt * dimensionMultipliers.misc;
  
  let sixInchTubePerFt = tubeLength * dimensionMultipliers.sixTube;
  if (height < 40) ae = tubeLength * dimensionMultipliers.twelveTube;
  if (height > 39) af = tubeLength * dimensionMultipliers.fourteenTube;
  
  //calculate excess inches
  let heightRemainder = (height - Math.floor(height)) * 12;
  let widthRemainder = (width - Math.floor(width)) * 12;
  
  //'inches fix'
  let roundUpPackLength = Math.ceil(height + 3);
  let PackLengthM = Math.round(roundUpPackLength * (1 / units.meters) * 100) / 100;
  let inchHeightScreen = (Math.floor(height) * 12) + Math.floor(heightRemainder);
  let inchWidthScreen = (Math.floor(width) * 12) + Math.floor(widthRemainder);
  let foldToFoldWidth = (inchHeightScreen / 4) - 5.5;
  let foldedOutsideWidthRounded = Math.ceil(((inchHeightScreen - 5) / 4) + 3);
  let crateLength = foldedOutsideWidthRounded + 18;
  let CrateLengthM = Math.round(crateLength * (1 / units.meters) * 100) / 100;
  let twelveInchTubeWeight = (foldToFoldWidth / 12) * dimensionMultipliers.twelveTube;
  
  
  let packagingCost, packagingDimensions, packagingDimensionsM, ifRolled, ifFoldedSilver, ifFoldedWhite, trayOrCrateWeight;
  
  switch (packaging) {
  	case packagingTypes.tubeOnly:
      packagingCost = packagingPrices.tube * height;
      packagingDimensions = roundUpPackLength + dimensionStrings.tubeSize;
      packagingDimensionsM = PackLengthM + dimensionStrings.tubeSizeM;
      ifRolled = 1;
      ifFoldedSilver = 0;
      ifFoldedWhite = 0;
      trayOrCrateWeight = 0;
      break;
    case packagingTypes.trayTube:
      packagingCost = packagingPrices.tray * height;
      packagingDimensions = roundUpPackLength + dimensionStrings.traySize;
      packagingDimensionsM = PackLengthM + dimensionStrings.traySizeM;
      ifRolled = 1;
      ifFoldedSilver = 0;
      ifFoldedWhite = 0;
      trayOrCrateWeight = (height + 3) * dimensionMultipliers.trays;
      break;
  	case packagingTypes.rolledCrate:
      packagingCost = packagingPrices.crate * height;
      packagingDimensions = roundUpPackLength + dimensionStrings.crateSize;
      packagingDimensionsM = PackLengthM + dimensionStrings.crateSizeM;
      ifRolled = 1;
      ifFoldedSilver = 0;
      ifFoldedWhite = 0;
      trayOrCrateWeight = (height + 3) * dimensionMultipliers.crates;
      break;
  	case packagingTypes.foldedCrate:
      packagingCost = packagingPrices.foldedSilver * height;
      packagingDimensions = roundUpPackLength + dimensionStrings.foldedSilverSize;
      packagingDimensionsM = PackLengthM + dimensionStrings.foldedSilverSizeM;
      ifRolled = 0;
      ifFoldedSilver = 1;
      ifFoldedWhite = 0;
      trayOrCrateWeight = 0;
      break;
  	case packagingTypes.foldedBox:
      packagingCost = packagingPrices.foldedWhite;
      packagingDimensions = dimensionStrings.foldedWhiteSize;
      packagingDimensionsM = dimensionStrings.foldedWhiteSizeM;
      ifRolled = 0;
      ifFoldedSilver = 1;
      ifFoldedWhite = 0;
      trayOrCrateWeight = 0;
      break;
    default:
      return false;
      break;
  }
  
  //calculate values
  let BG = ((foldToFoldWidth + 20) / 12) * (dimensionMultipliers.crates * 1.3) + (sqFt * dimensionMultipliers.vinyl) + (sqFt * dimensionMultipliers.misc);
  let BH = Math.ceil(BG / 10) * 10;
  let ifRolledSubtotal = vinylPerSqFt + sixInchTubePerFt + AE + AF + trayOrCrateWeight + miscPerSqFt;
  let approxWeightLb = ((Math.ceil(ifRolledSubtotal / 10) * 10) * ifRolled) + (BH * ifFoldedSilver) + ((Math.ceil(((sqFt * dimensionMultipliers.vinyl) + (sqFt * dimensionMultipliers.misc)) / 10) * 10) * ifFoldedWhite);
  let approxWeightKg = approxWeightLb * 0.45359237;
  
  //build output response
  let res = {};
  
  function toPlaces(n, p) {
    let m = 10 ** p;
    return Math.round(n * m) / m;
  }
  
  res["Screen Height (FT)"] = height;
  res["Screen Width (FT)"] = width;
  res["Screen Height (M)"] = height * (1 / units.meters);
  res["Screen Width (M)"] = width * (1 / units.meters);
  res["Screen Area (SQ FT)"] = sqFt;
  res["Screen Area (SQ M)"] = sqFt * (units.meters ** 2);
  res["Coating & Gain"] = coating;
  res["Packaging Type"] = packaging;
  res["Screen Cost (USD)"] = screenCost;
  res["Packaging Cost (USD)"] = packagingCost;
  res["Approximate Weight (LB)"] = Math.round(approxWeightLb);
  res["Approximate Weight (KG)"] = Math.round(approxWeightKg);
  res["Packaging Dimensions (US)"] = packagingDimensions;
  res["Packaging Dimensions (Metric)"] = packagingDimensionsM;
  
  for (let i in res) {
    let r = toPlaces(res[i], 2);
    if (isNaN(r)) {
      continue;
    }
    res[i] = r;
  }
  
  return res;
}